import React from 'react'
import { Input, Grid, Typography } from '@mui/material';


function ListOfDrugs({ state, handleChange, language }) {
    let listOfDrugs = []
    let title = ""
    if (state.drugs != null && state.drugs.some(e => e.value === 'Not on any medication') === false) {
        if (language === "questions" && state.drugs.some(e => e.value === 'Not on any medication') === false) {
            title = "Please specify the name of the drug you are taking"
        }
        else if (language === "questions_chi" && state.drugs.some(e => e.value === 'Not on any medication') === false) {
            title = "请明确说明你使用的药物的名"
        }
        listOfDrugs = state.drugs.map((answers) =>
            <Grid key={answers.value} container spacing={2} mt="24px" mb="32px" alignItems="center" justifyContent='center'>
                <Grid item xs={12} sm={4}>
                    <Typography textAlign="left">{answers.label}:</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Input
                        name={answers.value.split(" ")[0]}
                        key={answers.value.split(" ")[0]} 
                        value={state[answers.value.split(" ")[0]] ?? ' '}
                        onChange={handleChange}
                        inputProps={{ style: { textAlign: 'left', padding: '12px', marginTop: '16px' } }}
                        fullWidth={true}
                        placeholder="Name Of Drug..."
                    />
                </Grid>
            </Grid>)
    }
    if (typeof state.drugs != 'undefined' && state.drugs.length > 0) {
        return (
            <div>
                <Typography variant='h6' textAlign="center" mt="4rem">{title}</Typography>
                {listOfDrugs}
            </div>
        )
    } else {
        return null
    }
}

export default ListOfDrugs
